module.exports = __webpack_public_path__ + "img/rx210.ebf81386.png";